<script>
import PlayIcon from "../Youtube/PlayIcon.vue";
import ModalView from "./ModalView.vue";

export default {
  name: "VideoSliderView",
  components: {ModalView, PlayIcon},
  props: ['videos', 'length'],
  data() {
    return {
      imageLoaded: false,
      baseAssetUrl: window.baseAssetUrl,
      carouselVideo: [],
      isOpenModal: false,
      selectedVideo: null,
      isNeedButtons: false,
      firstIndex: 0,
      doubleVideo: [],

      canScrollLeft: false,
      canScrollRight: false,
    }
  },
  methods: {
    setVideoList() {
      this.isNeedButtons = this.videos.length > this.length;

      if (this.isNeedButtons){
        this.doubleVideo = [...this.videos, ...this.videos];

        this.setCarouselVideo()
      } else {
        this.carouselVideo = this.videos
      }
      //
      // this.carouselVideo = this.isNeedButtons ? this.videos.slice(this.videos.length - this.length) : this.videos;
    },
    setCarouselVideo() {

      if (this.firstIndex < 0) {
        this.firstIndex+= this.videos.length
      } else if(this.firstIndex > this.videos.length){
        this.firstIndex-= this.videos.length
      }

      this.carouselVideo = this.doubleVideo.slice(this.firstIndex, this.firstIndex + Number(this.length))
    },
    prevVideo() {
      this.firstIndex--
      this.setCarouselVideo()
    },
    nextVideo() {
      this.firstIndex++
      this.setCarouselVideo()
    },
    openModalWithVideo(video) {
      if (video.isVimeo){
        const url = `https://player.vimeo.com/video/${video.id}`

        video.video = url
        video.isVideo = true;
      } else {
        video.isVideo = true;
        video.isVimeo = false;
      }

      this.selectedVideo = video;
      this.isOpenModal = true;
    },

    checkScroll() {
      const container = this.$refs.scrollContainer;
      this.canScrollLeft = container.scrollLeft > 0;
      this.canScrollRight =
        container.scrollLeft + container.clientWidth < container.scrollWidth;
    },

    scrollLeft() {
      const container = this.$refs.scrollContainer;
      const firstChild = container.firstElementChild;

      if (firstChild) {
        const childWidth = firstChild.offsetWidth; // Get the width of the first child
        container.scrollBy({
          left: -childWidth, // Scroll by the width of the first child
          behavior: 'smooth',
        });
      }
    },

    scrollRight() {
      const container = this.$refs.scrollContainer;
      const firstChild = container.firstElementChild;

      if (firstChild) {
        const childWidth = firstChild.offsetWidth; // Get the width of the first child
        container.scrollBy({
          left: childWidth, // Scroll by the width of the first child
          behavior: 'smooth',
        });
      }
    }

  },
  mounted() {
    this.setVideoList();
    this.checkScroll()
  }
}
</script>

<template>
  <div>
<!--    <div class="flex flex-col md:flex-row">-->
      <modal-view v-if="isOpenModal" :isCarousel="false" @close="isOpenModal = false" :entity="selectedVideo"/>
<!--      <div class="flex flex-col w-full relative max-w-full">-->
<!--        <span class="text-2xl font-bold py-2 md:text-4xl">Related Videos</span>-->
<!--        <div class="flex flex-row w-full mt-4">-->
<!--          <div class="flex relative flex-row gap-3 w-full">-->
<!--            <template v-for="(video, key) in carouselVideo">-->
<!--              <div class="w-full max-w-[25%]">-->
<!--                <div-->
<!--                  class="video-slide w-full relative block m-0"-->
<!--                  :title="video.title"-->
<!--                >-->
<!--                  &lt;!&ndash;                <a :href="video.detail_page_url" target="_blank">&ndash;&gt;-->
<!--                  <div-->
<!--                    class="cursor-pointer"-->
<!--                    @click="openModalWithVideo(video)"-->
<!--                  >-->
<!--                    <img class="playlist-thumb w-full video-thumb mb-2" :src="video.thumbnail"-->
<!--                         :alt="video.title + ' Thumbnail'">-->
<!--                    <div-->
<!--                      class="hover:cursor-pointer opacity-0 transform absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 play-icon">-->
<!--                      <play-icon></play-icon>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                  <template v-if="isNeedButtons">-->
<!--                    <button-->
<!--                      v-if="key === 0"-->
<!--                      @click="prevVideo"-->
<!--                      class="absolute left-[-5%] top-1/2 z-10 left-0 transform -translate-y-1/2 bg-we-yellow text-white p-2 rounded-full"-->
<!--                    >-->
<!--                      <svg class="w-4 md:w-6 h-4 md:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"-->
<!--                           xmlns="http://www.w3.org/2000/svg">-->
<!--                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>-->
<!--                      </svg>-->
<!--                    </button>-->
<!--                    <button-->
<!--                      v-if="key === carouselVideo.length - 1"-->
<!--                      @click="nextVideo"-->
<!--                      class="absolute right-[-5%] top-1/2 z-10 right-0 transform -translate-y-1/2 bg-we-yellow text-white p-2 rounded-full"-->
<!--                    >-->
<!--                      <svg class="w-4 md:w-6 h-4 md:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"-->
<!--                           xmlns="http://www.w3.org/2000/svg">-->
<!--                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>-->
<!--                      </svg>-->
<!--                    </button>-->
<!--                  </template>-->
<!--                </div>-->
<!--                <label v-if="video.isVimeo" class="rounded-full px-2 py-0.5 bg-we-yellow justify-center items-center text-black text-[10px] font-semibold ">-->
<!--                  Product Video-->
<!--                </label>-->
<!--                <label v-else class="rounded-full px-2 py-0.5 bg-we-light  justify-center items-center text-white text-[10px] font-semibold">-->
<!--                  Tutorial-->
<!--                </label>-->
<!--                <h3 class="font-bold m-0 text-xs md:text-base heading-five mt-4">-->
<!--                  <a target="_blank" :href="video.detail_page_url" :title="video.title">-->
<!--                    {{ video.short_title }}-->
<!--                  </a>-->
<!--                </h3>-->
<!--                <div class="hidden md:block timestamp my-2">{{ video.human_published_at }}</div>-->
<!--              </div>-->
<!--            </template>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->

    <div class="flex justify-between">
      <span class="text-2xl font-bold py-2 md:text-4xl">Related Videos</span>

      <div class="flex" v-if="canScrollLeft || canScrollRight ">
        <button class="rounded-3xl disabled:cursor-not-allowed"
                :class="{
                    'disabled' : !canScrollLeft
                  }"
                @click="scrollLeft"

                :disabled="!canScrollLeft"
        >
          <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g clip-path="url(#clip0_1778_939)"><path d="M17.707 11.707l-1.414-1.414L9.586 17l6.707 6.707 1.414-1.414L13.414 18H23v-2h-9.586l4.293-4.293z" fill="#367C2B"/><circle cx="17" cy="17" r="16.5" stroke="#367C2B"/></g><defs><clipPath id="clip0_1778_939"><path fill="#fff" d="M0 0h34v34H0z"/></clipPath></defs></svg>
        </button>
        <button class="rounded-3xl rotate-180 ml-2 disabled:cursor-not-allowed"
                :class="{
                    'disabled' : !canScrollRight
                  }"
                @click="scrollRight"
                :disabled="!canScrollRight"
        >
          <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g clip-path="url(#clip0_1778_939)"><path d="M17.707 11.707l-1.414-1.414L9.586 17l6.707 6.707 1.414-1.414L13.414 18H23v-2h-9.586l4.293-4.293z" fill="#367C2B"/><circle cx="17" cy="17" r="16.5" stroke="#367C2B"/></g><defs><clipPath id="clip0_1778_939"><path fill="#fff" d="M0 0h34v34H0z"/></clipPath></defs></svg>
        </button>
      </div>
    </div>

    <div
      ref="scrollContainer"
      class="flex w-full scrollbar-hide overflow-x-auto snap-x snap-mandatory gap-4"
      @scroll="checkScroll"
    >
      <div class="flex-none w-[285px] xs:w-[338px] snap-start "
           v-for="(video, key) in videos">
        <div
          class="video-slide w-full relative block m-0"
          :title="video.title"
        >
          <!--                <a :href="video.detail_page_url" target="_blank">-->
          <div
            class="cursor-pointer"
            @click="openModalWithVideo(video)"
          >
            <img class="playlist-thumb w-full video-thumb mb-2" :src="video.thumbnail"
                 :alt="video.title + ' Thumbnail'">
            <div
              class="hover:cursor-pointer opacity-0 transform absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 play-icon">
              <play-icon></play-icon>
            </div>
          </div>
        </div>
        <label v-if="video.isVimeo" class="rounded-full px-2 py-0.5 bg-we-yellow justify-center items-center text-black text-[10px] font-semibold ">
          Product Video
        </label>
        <label v-else class="rounded-full px-2 py-0.5 bg-we-light  justify-center items-center text-white text-[10px] font-semibold">
          Tutorial
        </label>
        <h3 class="font-bold m-0 text-xs md:text-base heading-five mt-4">
          <a target="_blank" :href="video.detail_page_url" :title="video.title">
            {{ video.short_title }}
          </a>
        </h3>
        <div class="timestamp my-2">{{ video.human_published_at }}</div>
      </div>
    </div>
  </div>

</template>


<style scoped>

.scrollbar-hide {
  -ms-overflow-style: none; /* Internet Explorer 10+ */
  scrollbar-width: none; /* Firefox */
}

.scrollbar-hide::-webkit-scrollbar {
  display: none; /* Chrome, Safari, and Opera */
}

button.disabled g path, button.disabled g circle {
  filter: grayscale(1);
}

</style>



// WEBPACK FOOTER //
// resources/js/Components/new/VideoSliderView.vue